import React from 'react'
import { observer } from 'mobx-react-lite';
import './index.scss';
import shareFbIcon from '@assets/img/share-fb.svg';
import { useTranslation } from 'react-i18next';
import { useShareReplace } from '@commons/shareLink';
import { scroller } from 'react-scroll';
import { MGMShares } from '@interfaces/portal';
interface FacebookProps {
    mgmShares: MGMShares,
    mgmCode: string
}
const FacebookShare:React.FC<FacebookProps> = observer((props)=> {
    // https://refer.hkbn.net/share/customer/facebook?languageCode=tc&mgmCode=RHKBNI78938&serviceType=
    // https://www.facebook.com/sharer/sharer.php?u=https://r.hkbn.net//f/RHKBNI78938
    // https://www.facebook.com/share_channel/?type=reshare&link=https%3A%2F%2Fr.hkbn.net%2F%2Ff%2F12345678&app_id=966242223397117&source_surface=external_reshare&display&hashtag#
    // <FacebookShareButton icon={props.staticContent && props.staticContent.btnShareFacebookIcon.iv[0].url} mgmCode={referralCode} backgroundColor={props.staticContent && props.staticContent.btnShareFacebookButtonBackgroundColor.iv[0].data.colorCode.iv} showDefault={true} />
    const {i18n} = useTranslation();
    
    const { replaceShareMessage } = useShareReplace()
    /**
     * 
     * @returns todo
     * app msg link
     */
    const getShareMessageData = () => {
        let msg = replaceShareMessage(props.mgmShares.facebookContent || '', "facebook", i18n.language === 'zh-HK' ? "tc" : "en", props.mgmCode);
        return msg;
    }
    
    const handleClickShareButton = async () => {
        if (props.mgmCode) {
            if (window &&
                window.navigator &&
                window.navigator.userAgent &&
                (window.navigator.userAgent.indexOf("MyHKBNApp;Android") > -1 ||
                window.navigator.userAgent.indexOf("MyHKBNApp;iOS") > -1)) {
                // support myHKBN In app browser to share
                var dsBridge = require("dsbridge");
                var params = {
                "type": "operation",
                "function": "share",
                "extraData": getShareMessageData()
                }
                dsBridge.call("nativeAsyncBridgeMessage", JSON.stringify(params), (callbackParam: any) => myHkbnCallback(callbackParam));
            }
            else {
                let url = await getRedirectUrlRequest(props.mgmCode);
                window.open(url);
            }
        } else {
            scroller.scrollTo("account", {
                smooth: 'easeOutQuad',
                duration: 800,
            })
        }
    };

    const myHkbnCallback = (callbackParam: any) => { }

    const getRedirectUrlRequest = async (code: string) => {
        window.open(`http://www.facebook.com/sharer/sharer.php?u=${REACT_APP_ReferralShortURL}f/${code}`)
        // window.open(`http://www.facebook.com/sharer/sharer.php?u=https://stage-myacc-api.hkbn.net/Redirection/${code}/tc`)
    };
    
    return (
        <div className='sharemsg-icon' onClick={handleClickShareButton}>
            <img src={shareFbIcon} alt="" />
        </div>
    )
})

export default FacebookShare;